import React, {
  createContext,
  useContext,
  useEffect,
  useState
} from "react";

import { jwtDecode } from "jwt-decode";
import api from "../utils/api";

const AuthContext = createContext();

export const useAuth = () => {

  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(
      "useAuth must be used within AuthProvider"
    );
  }

  return context;

};

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ===============================
     CHECK LOGIN ON APP START
  =============================== */

  useEffect(() => {

    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");

    if (!token || !savedUser) {

      setLoading(false);
      return;

    }

    try {

      const decoded = jwtDecode(token);

      // Token expired
      if (decoded.exp * 1000 < Date.now()) {

        localStorage.clear();

        setUser(null);

        setLoading(false);

        return;

      }

      setUser(JSON.parse(savedUser));

    } catch (err) {

      console.error("Invalid token", err);

      localStorage.clear();

      setUser(null);

    }

    setLoading(false);

  }, []);

  /* ===============================
     LOGIN
  =============================== */

  const login = (token, userData) => {

    localStorage.setItem("token", token);

    localStorage.setItem(
      "user",
      JSON.stringify(userData)
    );

    setUser(userData);

  };

  /* ===============================
     LOGOUT
  =============================== */

  const logout = async () => {

    try {

      await api.post("/auth/logout");

    } catch (err) {

      console.log(err);

    }

    localStorage.clear();

    setUser(null);

    window.location.replace("/");

  };

    /* ===============================
     AUTO LOGOUT AFTER 30 MINUTES
  =============================== */

  useEffect(() => {

    if (!user) return;

    let timer;

    const logoutUser = () => {
      logout();
    };

    const resetTimer = () => {

      clearTimeout(timer);

      timer = setTimeout(
        logoutUser,
        30 * 60 * 1000
      );

    };

    resetTimer();

    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
      "click"
    ];

    events.forEach(event =>
      window.addEventListener(
        event,
        resetTimer
      )
    );

    return () => {

      clearTimeout(timer);

      events.forEach(event =>
        window.removeEventListener(
          event,
          resetTimer
        )
      );

    };

  }, [user]);

  /* ===============================
     AUTH VALUES
  =============================== */

  const value = {

    user,

    login,

    logout,

    loading,

    isAuthenticated: !!user

  };

  return (

    <AuthContext.Provider value={value}>

      {!loading && children}

    </AuthContext.Provider>

  );

};

export default AuthContext;